<template>
  <div>
    <v-navigation-drawer
      v-if="currentTemplate === 'templatePage'"
      v-model="drawer"
      width="380"
      absolute
      temporary
      :overlay-opacity="0"
    >
      <DevLeftSidebar @closeDrawer="drawer = !drawer" />
    </v-navigation-drawer>

    <v-app-bar elevation="1" color="grey darken-3" dark fixed tile dense>
      <v-icon
        v-if="currentTemplate === 'templatePage'"
        @click.stop="drawer = !drawer"
        class="mr-4"
        title="Configurações de Telas"
        v-text="'menu'"
      />

      <v-img
        src="../../assets/dev/logo-dev-white-orange.png"
        class="cursor-pointer"
        max-width="72"
        max-height="auto"
        @click="handleLoadTemplate('templateHome')"
      />

      <v-spacer />

      <div>
        <DevEnvironments :icon="false" />

        <span v-if="selectedPage !== ''">
          /
          <span class="mx-2 body-2">{{ selectedPage }}</span>
          /
        </span>
        <v-menu v-if="selectedPage !== ''" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small text dark v-on="on">
              {{ currentMode }}
              <v-icon small class="ml-1">expand_more</v-icon>
            </v-btn>
          </template>

          <v-list dense class="py-0">
            <v-list-item
              v-for="mode in modes.filter(mode => mode !== currentMode)"
              :key="mode"
              @click="changeModes(mode)"
            >
              <v-list-item-title>{{ mode }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <v-spacer />

      <v-tooltip bottom v-if="currentTemplate === 'templatePage' && selectedPage !== ''">
        <template v-slot:activator="{ on }">
          <SaveIcon v-on="on" @click="confirmSaveInFolder" class="cursor-pointer" />
        </template>

        <span>Salvar</span>
      </v-tooltip>

      <v-tooltip
        bottom
        v-if="currentTemplate === 'templateLayoutConfig' && selectedPortal && 'portalId' in selectedPortal"
      >
        <template v-slot:activator="{ on }">
          <SaveIcon v-on="on" @click="handleSaveConfigLayout" class="cursor-pointer" />
        </template>

        <span>Salvar</span>
      </v-tooltip>

      <div class="d-flex align-center">
        <v-menu
          left
          offset-y
          :nudge-bottom="10"
          :max-width="400"
          :close-on-content-click="false"
          transition="scroll-y-transition"
          origin="top center"
          class="dev-account"
          elevation="0"
        >
          <template v-slot:activator="{ on }">
            <GridIcon v-on="on" size="22" class="cursor-pointer ml-4" color="grey darken-3" />
          </template>

          <v-card class="envronment-menu-arrow-top d-flex" elevation="0">
            <v-card
              class="modes-navigation"
              @click="handleLoadTemplate('templateMenu')"
              width="100px"
              elevation="0"
              :disabled="currentTemplate === 'templateMenu'"
            >
              <v-img src="static/svg/dev-icon-menu.svg" width="100px" alt="Imagem de Menus" />

              <p class="font-weight-bold subtitle-2 grey--text text--darken-3 mb-2">Menus</p>
            </v-card>

            <v-card
              class="modes-navigation"
              @click="handleLoadTemplate('templateLayoutConfig')"
              width="100px"
              elevation="0"
              :disabled="currentTemplate === 'templateLayoutConfig'"
            >
              <v-img src="static/svg/dev-icon-layout.svg" width="100px" alt="Imagem de Layout" />

              <p class="font-weight-bold subtitle-2 grey--text text--darken-3 mb-2">Layout</p>
            </v-card>

            <v-card
              class="modes-navigation"
              @click="handleLoadTemplate('templatePage')"
              width="100px"
              elevation="0"
              :disabled="currentTemplate === 'templatePage'"
            >
              <v-img src="static/svg/dev-icon-page.svg" width="100px" alt="Imagem de Páginas" />

              <p class="font-weight-bold subtitle-2 grey--text text--darken-3 mb-2">Páginas</p>
            </v-card>

            <v-card
              class="modes-navigation"
              @click="handleLoadTemplate('templateModule')"
              width="100px"
              elevation="0"
              :disabled="currentTemplate === 'templateModule'"
            >
              <v-img src="static/svg/dev-icon-module.svg" width="100px" />

              <p class="font-weight-bold subtitle-2 grey--text text--darken-3 mb-2">Módulos</p>
            </v-card>
          </v-card>
        </v-menu>

        <DevAccount />
      </div>
    </v-app-bar>

    <v-dialog v-model="confirmPageChanges.dialog" persistent max-width="400px">
      <v-card>
        <v-card-title class="px-4 d-flex justify-space-between grey darken-3">
          <v-spacer />
          <v-icon
            color="white"
            :size="20"
            @click="confirmPageChanges = { dialog: false, origin: '', fileName: '', redirect: '' }"
            >close</v-icon
          >
        </v-card-title>

        <v-divider />

        <v-card-text class="mt-4 px-4">
          <span class="text-subtitle-1 font-weight-medium">Você tem alterações, deseja salvar?</span>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="grey darken-3" dark @click="confirmSaveInFolder">
            <SaveIcon size="16" class="mr-2" />Salvar
          </v-btn>

          <v-btn color="error" @click="discartChanges"> <Trash2Icon size="16" class="mr-2" />Descartar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDialogPage" persistent max-width="400px">
      <v-card>
        <v-card-title class="px-4 d-flex justify-space-between grey darken-3">
          <span class="text-subtitle-1 font-weight-medium white--text">Defina o nome do arquivo</span>
          <v-spacer />

          <v-icon color="white" :size="20" @click="closeConfirmDialog">close</v-icon>
        </v-card-title>

        <v-divider />

        <v-card-text class="my-2 pa-4">
          <v-text-field
            v-model="selectedPage"
            @input="handleDisableSave"
            label="Nome"
            type="text"
            required
            hide-details
            dense
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="grey darken-3" :dark="!disableSave" :disabled="disableSave" @click="handleSavePage">
            <SaveIcon size="16" class="mr-2" />Salvar
          </v-btn>

          <v-btn color="error" @click="closeConfirmDialog"> <RotateCwIcon size="16" class="mr-2" />Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { GridIcon, SaveIcon, Trash2Icon, RotateCwIcon } from 'vue-feather-icons';

import { MODE_LIST, OTHERS_MODES } from '@/helpers/dev/modeComponents';
import { addMandatoryParameters, clearSchemaBeforeSave, INITIAL_SCHEMA } from '@/helpers/dev';
import { savePage, saveConfigLayout, getPageByName } from '@/services/dev';

export default {
  components: {
    DevLeftSidebar: () => import('@/components/dev/dev-left-sidebar'),
    DevAccount: () => import('@/components/dev/dev-account'),
    DevEnvironments: () => import('@/components/dev/dev-environments'),
    GridIcon,
    SaveIcon,
    Trash2Icon,
    RotateCwIcon
  },

  data: () => ({
    drawer: null,
    showDialogPage: false,
    disableSave: true
  }),

  computed: {
    schema() {
      return this.$store.getters['dev/getSchema'];
    },

    typeOfPageEditing() {
      return this.$store.getters['dev/getTypeOfPageEditing'];
    },

    currentTemplate() {
      return this.$store.getters['dev/getCurrentTemplate'];
    },

    currentMode() {
      return this.$store.getters['dev/getCurrentMode'];
    },

    selectedEnvironment() {
      return this.$store.getters['dev/getSelectedEnvironment'];
    },

    selectedPortal() {
      return this.$store.getters['dev/getSelectedPortal'];
    },

    selectedModule() {
      return this.$store.getters['dev/getSelectedModule'];
    },

    modes() {
      return this.$store.getters['dev/getModes'];
    },

    configLayout() {
      return this.$store.getters['dev/getConfigLayout'];
    },

    selectedPage: {
      get() {
        let getSelectedPage = this.$store.getters['dev/getSelectedPage'];

        if (getSelectedPage !== '') this.disableSave = false;

        return getSelectedPage;
      },

      set(val) {
        this.$store.dispatch('dev/setSelectedPage', val);
      }
    },

    confirmPageChanges: {
      get() {
        return this.$store.getters['dev/getConfirmPageChanges'];
      },

      set(val) {
        this.$store.dispatch('dev/setConfirmPageChanges', val);
      }
    },

    selectedModule() {
      return this.$store.getters['dev/getSelectedModule'];
    }
  },

  methods: {
    handleLoadTemplate(param) {
      if (this.typeOfPageEditing !== '' && JSON.stringify(this.schema) !== JSON.stringify(this.initialSchema)) {
        this.$store.dispatch('dev/setConfirmPageChanges', {
          dialog: true,
          origin: 'header',
          fileName: '',
          redirect: param
        });

        return;
      }

      this.$store.dispatch('dev/setTypeOfPageEditing', '');
      this.$store.dispatch('dev/setSchema');
      this.$store.dispatch('dev/setSelectedPage', '');
      this.$store.dispatch('dev/setCurrentTemplate', param);
    },

    // --> Salva na pasta especificada no server -------------------------------------------------------------------------------
    confirmSaveInFolder() {
      this.confirmPageChanges = { dialog: false, origin: '', fileName: '', redirect: '' };
      this.showDialogPage = true;
      this.disableSave = false;
    },

    closeConfirmDialog() {
      this.showDialogPage = false;
      this.disableSave = true;
    },

    handleDisableSave() {
      this.selectedPage.length >= 3 ? (this.disableSave = false) : (this.disableSave = true);
    },

    async discartChanges() {
      this.$store.dispatch('dev/setSchema');
      this.$store.dispatch('dev/setSelectedPage', '');
      this.$store.dispatch('dev/setTypeOfPageEditing', '');
      this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(INITIAL_SCHEMA)));
      this.$store.dispatch('dev/setSelectedComponent', false);
      this.$store.dispatch('dev/setSelected', {});
      this.$store.dispatch('dev/setSidebarTab', 'tab-1');

      if (this.confirmPageChanges.origin === 'header') {
        this.$store.dispatch('dev/setCurrentTemplate', 'templateHome');
        this.$store.dispatch('dev/setTypeOfPageEditing', '');
      }

      if (this.confirmPageChanges.origin === 'edit') {
        const { data: schema } = await getPageByName({
          portalId: this.selectedPortal.portalId,
          name: this.confirmPageChanges.fileName,
          environmentId: this.selectedEnvironment.id,
          moduleId: this.selectedModule.id,
          moduleFolder: this.selectedModule.folder
        });

        await this.$store.dispatch('dev/setSchema', addMandatoryParameters(schema));

        await this.$store.dispatch('page/load', { page: 'dev', mode: this.modes[0] });

        this.$store.dispatch('dev/setCurrentMode', this.modes[0]);
        this.$store.dispatch('dev/setSelectedPage', this.confirmPageChanges.fileName);
        this.$store.dispatch('dev/setTypeOfPageEditing', 'edit');
        this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(addMandatoryParameters(schema))));
        this.$store.dispatch('dev/setAccordionType', this.currentMode === 'list' ? MODE_LIST : OTHERS_MODES);
      }

      if (this.confirmPageChanges.origin === 'new') {
        this.$store.dispatch('dev/setTypeOfPageEditing', 'new');
      }

      if (this.confirmPageChanges.redirect !== '') {
        this.$store.dispatch('dev/setCurrentTemplate', this.confirmPageChanges.redirect);
      }

      this.confirmPageChanges = { dialog: false, origin: '', fileName: '', redirect: '' };
    },

    async handleSavePage() {
      const schema = clearSchemaBeforeSave(JSON.parse(JSON.stringify(this.schema)), this.modes);

      try {
        await savePage({
          portalId: this.selectedPortal.portalId,
          file: JSON.stringify(schema),
          name: this.selectedPage,
          moduleId: this.selectedModule.id,
          moduleFolder: this.selectedModule.folder
        });

        this.$store.dispatch('dev/setSchema');
        this.$store.dispatch('dev/setSelectedPage', '');
        this.$store.dispatch('dev/setTypeOfPageEditing', '');
        this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(INITIAL_SCHEMA)));

        this.closeConfirmDialog();

        this.$store.dispatch('notification/showNotification', {
          color: 'success',
          text: `Arquivo salvo com sucesso!`,
          showIconNotification: false
        });
      } catch (err) {
        this.$store.dispatch('notification/showNotification', {
          color: 'error',
          text: `Ocorreu um erro ao salvar o arquivo`,
          showIconNotification: true
        });
      }
    },

    async handleSaveConfigLayout() {
      const { status } = await saveConfigLayout(this.selectedPortal.portalId, JSON.stringify(this.configLayout));

      if (status === 204) {
        this.$store.dispatch('notification/showNotification', {
          color: 'success',
          text: 'configLayout alterado com sucesso!',
          showIconNotification: false
        });
      }
    },

    // --> Alterna os modos de tela! ---------------------------------------------------------------------------------------
    async changeModes(mode) {
      if (mode === this.currentMode) return;

      await this.$store.dispatch('page/load', { page: 'dev', mode });
      this.$store.dispatch('dev/setAccordionType', mode === 'list' ? MODE_LIST : OTHERS_MODES);

      // // --> Retorna para tab-1 e limpa se houver algum componente selecionado!
      this.$store.dispatch('dev/setSelected', {});
      this.$store.dispatch('dev/setCurrentMode', mode);
      this.$store.dispatch('dev/setSelectedComponent', false);
      this.$store.dispatch('dev/setSidebarTab', 'tab-1');
    }
  }
};
</script>

<style lang="scss" scoped>
.v-menu__content {
  overflow-y: initial;
  overflow-x: initial;
  contain: none;
}

.envronment-menu-arrow-top {
  &:before {
    bottom: 100%;
    right: 6px;
    margin-left: -6px;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-width: 6px;
    border-bottom-color: #fff;
  }
}

.modes-navigation {
  position: relative;

  p {
    position: absolute;
    bottom: 0;
    text-align: center;
    width: 100%;
  }
}
</style>
